import { render, staticRenderFns } from "./AdminStudyTypeForm.vue?vue&type=template&id=4ce00a22&"
import script from "./AdminStudyTypeForm.vue?vue&type=script&lang=js&"
export * from "./AdminStudyTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports